import store from '@Store';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { unavailableResultsMessage } from './ResultSetValidationConstants';
import { typeOfUnavailableResultsDialog } from './UnavailableResultsDialog';

export function openUnavailableResultsDialog({ message } = {}) {
  return updateDialog({
    id: typeOfUnavailableResultsDialog,
    dialogType: typeOfUnavailableResultsDialog,

    message: message || unavailableResultsMessage,
  });
}

export function dispatchOpenUnavailableResultsDialog(...args) {
  store.dispatch(openUnavailableResultsDialog(...args));
}
